export interface OpenCopilotParams {
  threadId?: string;
  documentId?: string;
  documentName?: string;
}

const EVENT = 'copilot:open'

export function openCopilot(params: OpenCopilotParams = {}): void {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: params }))
}

export function onOpenCopilot(handler: (p: OpenCopilotParams) => void): () => void {
  const listener = (e: Event) => handler((e as CustomEvent).detail || {})
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
